import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { identityAuth, useIdentityAuth } from '../auth';
import { PageWrapper } from '../resources/styling/appStyle';
import { BaseCSS } from 'styled-bootstrap-grid';
import { colors } from '../resources/theme/colors';
import { getIdentityUrl as identityUrlForCurrentHost } from '../utils/config';

const { pictonBlue } = colors;
const customCSS = `
@-ms-viewport {
  width: device-width;
}
html {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -ms-overflow-style: scrollbar;
}

*,
*::before,
*::after {
  -webkit-box-sizing: inherit;
          box-sizing: inherit;
}
.main-outer-wrapper {
  float: left;
  width: 100%;
}

.welcome-content{
  display: flex;
  align-items: center;
}
.school-name {
  font-weight: 600;
  color: ${pictonBlue} !important;
}
.mobile-wrapper {
  padding: 0;
  padding-bottom: 3.5rem;

}
`;

function ProtectedRoute(props) {
  const { user, loading, authenticated } = useIdentityAuth();
  const isSignedOut = !loading && (!authenticated || !user);
  const identityUrl = identityUrlForCurrentHost();

  useEffect(() => {
    if (isSignedOut && identityUrl) identityAuth.redirectToLogin();
  }, [isSignedOut, identityUrl]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <PageWrapper>
        <BaseCSS css={customCSS} />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div>Loading...</div>
        </div>
      </PageWrapper>
    );
  }

  // If not authenticated, redirect to Identity login
  if (isSignedOut) {
    if (!identityUrl) {
      console.error('IDENTITY_URL is not configured. Please check your .env file and restart the server.');
      return (
        <PageWrapper>
          <BaseCSS css={customCSS} />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', padding: '2rem' }}>
            <h2>Configuration Error</h2>
            <p>IDENTITY_URL is not set. Please configure REACT_APP_IDENTITY_URL in your .env file and restart the server.</p>
          </div>
        </PageWrapper>
      );
    }
    return null; // Don't render anything while redirecting
  }

  return (
    <PageWrapper>
      <BaseCSS css={customCSS} />
      <Route {...props} />
    </PageWrapper>
  );
}

export default ProtectedRoute